import { SproutAutomationMode } from "verdi-common/schemas/device/subSchemas/sproutAutomationSettings";

/**
 * Possible automation values
 * Maps enum keys to SproutAutomationMode values
 */
export const AUTOMATION_MODE: Record<string, SproutAutomationMode> = {
    ENABLED_DUTY_CYCLE: "dutyCycle",
    ENABLED_THRESHOLD: "threshold",
    DISABLED: "none",
};
